
// material-ui
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

// icons
import { IconExternalLink } from '@tabler/icons-react';

const OMS_URL = 'http://16.171.208.253/#!/';

export default function OMSSection() {
  const handleOpenOMS = () => {
    window.open(OMS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Open Office Management System">
      <Button
        onClick={handleOpenOMS}
        variant="contained"
        startIcon={<IconExternalLink size={18} />}
        sx={{
          ml: 1.5,
          mr: 1.5,
          textTransform: 'none',
          fontWeight: 700,
          fontSize: '0.9rem',
          borderRadius: '10px',
          px: 2,
          py: 0.8,

          // PHNX maroon theme
          backgroundColor: '#8B2A2A',
          color: '#ffffff',

          '&:hover': {
            backgroundColor: '#6E1F1F'
          }
        }}
      >
        OMS
      </Button>
    </Tooltip>
  );
}